 import service from '../Common'
 import constants from '../../../settings/shared/constants'
 
 function getAllCloudImages() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.cloudImages.getAllCloudImages,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function PostCloudImage(CloudImageData) {
     let jwtToken = localStorage.getItem('accessToken');
     let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
         return service({
             url: constants.api.cloudImages.postCloudImage,
             method: 'POST',
             headers: headers,
             data:  CloudImageData
         }); 
  }

  function getCloudImagesById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.cloudImages.getCloudImagesById+'/'+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 /**
  * Get images by cloud type & image type
  * @param {*} cloudType - AWS / AZURE / GOOGLE 
  * @param {*} imageType - CONTAINER / VIRTUAL_MACHINE
  */
 function getCloudImagesByType(cloudType, imageType) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
    let apiURL = constants.api.cloudImages.getAllCloudImages+'/'+cloudType+'/'+imageType

    if((cloudType === undefined) || (cloudType.length <= 0)) {
        apiURL = constants.api.cloudImages.getImageType+'/'+imageType
    }
        return service({    
            url: apiURL,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

  function updateCloudImage(upateData,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.cloudImages.updateCloudImage+id,
            method: 'PUT',
            headers: headers,
            data:  upateData
        }); 
 }

 function DeleteCloudImage(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.cloudImages.deleteCloudImage+id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
 }

 function getImageType() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.cloudImages.getImageType,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }
 function getimageRegionName(regionname) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.cloudImages.getimageRegionName+regionname,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

function getZoneName(zone) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
    return service({
        url: constants.api.cloudImages.getimageZoneName+zone,
        method: 'GET',
        headers: headers,
        data:  ''
    }); 

}

 function getArchitecture() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.cloudImages.getArchitecture,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }


 //To export authentication function
 const ImageMappingService = {
    getAllCloudImages,PostCloudImage,getCloudImagesById,updateCloudImage,DeleteCloudImage,
    getImageType,getimageRegionName,getArchitecture, getCloudImagesByType, getZoneName
 }
 
 export default ImageMappingService;
 